import {
  ICellCuListPayload,
  ICellListData,
  ICellListPayload,
  ICellsConfigData,
  ICellsCuConfigData,
  IDusNodeDataGridRow,
  IIPInterface,
  ILanDevice,
  ILteCellDataGridRow,
  INrCellDataGridRow,
  IRadioListBandData,
  IRadioNodesDataGridRow,
  IRfFeed,
  ISectorProvision,
  IZoneCellList,
  IZoneDevice,
  IltepeerInterfaces,
  IngpeerInterfaces,
} from "../../store/api/deviceConfig/types";

import { OPERATIONTYPES, xsdPathStr } from "../../globals/constants";
import { LOCAL_STORAGE } from "../../globals/globals";
import { IRfFeedToRim } from "./Inventory/types";
import { IDuCellInfo, IRnCellInfo } from "../../store/api/devices/types";
import { IOption } from "../Shared/Filter/types";
import { IKeyValue } from "../Administrations/types";

export const prepareLANDevicePayload = (
  lanDeviceFormData: ILanDevice | undefined,
  selectedLanDevice: ILanDevice | undefined,
  objectKey: string,
  operationType: string
) => {
  const { lanDevice, deletepath } = xsdPathStr;
  const lanDeviceIndex = `${lanDevice.internetGatewayDevice}.${lanDevice.lanDevice}`,
    lanEthernet = `${lanDevice.internetGatewayDevice}.${lanDevice.lanDevice}.${lanDeviceFormData?.index}.${lanDevice.lanEthernetInterfaceConfig}`;
  let oldLANDeviceData = {},
    newLANDeviceData = {};

  if (operationType === OPERATIONTYPES.UPDATE && !!selectedLanDevice && !!lanDeviceFormData) {
    Object.entries(selectedLanDevice).forEach(([oldkey, oldvalue]) => {
      Object.entries(lanDeviceFormData).forEach(([newkey, newvalue]) => {
        if (oldkey === newkey && oldvalue !== newvalue) {
          oldLANDeviceData = { ...oldLANDeviceData, [`${lanEthernet}.1.${lanDevice[oldkey]}`]: oldvalue };
          newLANDeviceData = { ...newLANDeviceData, [`${lanEthernet}.1.${lanDevice[newkey]}`]: newvalue };
        }
      });
    });
    //newLANDeviceData = { ...newLANDeviceData, [lanDeviceIndex]: lanDeviceFormData.index, [lanEthernet]: "1" };
  } else if (operationType === OPERATIONTYPES.DELETE && !!selectedLanDevice) {
    oldLANDeviceData = {};
    newLANDeviceData = {
      [`${deletepath}`]: `${lanDeviceIndex}.${selectedLanDevice.index}.`,
    };
  } else {
    oldLANDeviceData = {};
    newLANDeviceData = {
      [lanDeviceIndex]: lanDeviceFormData?.index,
      // [`${lanEthernet}.1.${lanDevice.name}`]: lanDeviceFormData.name,
      [`${lanEthernet}.1.${lanDevice.duplex}`]: lanDeviceFormData?.duplex,
      [`${lanEthernet}.1.${lanDevice.enable}`]: lanDeviceFormData?.enable?.toString(),
      [`${lanEthernet}.1.${lanDevice.maxBitRate}`]: lanDeviceFormData?.maxBitRate,
    };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: lanDeviceFormData?.index || selectedLanDevice?.index,
    tableId: `${lanDevice.tableId}.${lanDeviceFormData?.index || selectedLanDevice?.index}`,
    deviceObjectKey: objectKey, //"22056S52746" //"16200X18393",
    oldValue: { ...oldLANDeviceData },
    newValue: { ...newLANDeviceData },
  };
};

export const prepareZoneDevicePayload = (
  zoneDeviceFormData: IZoneDevice | undefined,
  selectedLanDevice: IZoneDevice | undefined,
  objectKey: string,
  operationType: string,
  nodeType: string
) => {
  const { zoneDevice } = xsdPathStr;
  let oldLANDeviceData = {},
    newLANDeviceData = {};
  const nodeTypeKey = `${nodeType === "SN" ? zoneDevice.lte : zoneDevice.ng}`;
  const zoneDeviceIndex = `${zoneDevice.internetGatewayDevice}.${zoneDevice.fapService}.1`;
  const nodeTypeIndex = `${zoneDeviceIndex}.${nodeTypeKey}.${zoneDevice.zone}`;
  const configType = `${zoneDevice.config}.${zoneDevice.ranId}.${zoneDevice.rfId}`;
  const zoneBasePath = `${nodeTypeIndex}.${zoneDeviceFormData?.index}.${configType}`;
  let bandWidth = {};
  if (operationType === OPERATIONTYPES.CREATE) {
    if (nodeType === "SN") {
      bandWidth = {
        [`${nodeTypeIndex}.${zoneDeviceFormData?.index}.${configType}.${zoneDevice.dlBandwidth}`]: Number(zoneDeviceFormData?.dlBandwidth),
        [`${nodeTypeIndex}.${zoneDeviceFormData?.index}.${configType}.${zoneDevice.ulBandwidth}`]: Number(zoneDeviceFormData?.ulBandwidth),
        [`${nodeTypeIndex}.${zoneDeviceFormData?.index}.${configType}.${zoneDevice.eARFCNDL}`]: Number(zoneDeviceFormData?.eARFCNDL),
        [`${nodeTypeIndex}.${zoneDeviceFormData?.index}.${configType}.${zoneDevice.eARFCNUL}`]: Number(zoneDeviceFormData?.eARFCNUL),
        [`${nodeTypeIndex}.${zoneDeviceFormData?.index}.${zoneDevice.type}`]: zoneDeviceFormData?.zoneType,
        [`${nodeTypeIndex}.${zoneDeviceFormData?.index}.${zoneDevice.description}`]: zoneDeviceFormData?.description || "",
      };
    } else {
      bandWidth = {
        [`${nodeTypeIndex}.${zoneDeviceFormData?.index}.${configType}.${zoneDevice.downlinkBandwidthMhz}`]: Number(zoneDeviceFormData?.dlBandwidth),
        [`${nodeTypeIndex}.${zoneDeviceFormData?.index}.${configType}.${zoneDevice.uplinkBandwidthMhz}`]: Number(zoneDeviceFormData?.ulBandwidth),
        [`${nodeTypeIndex}.${zoneDeviceFormData?.index}.${configType}.${zoneDevice.ARFCNDL}`]: Number(zoneDeviceFormData?.eARFCNDL),
        [`${nodeTypeIndex}.${zoneDeviceFormData?.index}.${configType}.${zoneDevice.ARFCNUL}`]: Number(zoneDeviceFormData?.eARFCNUL),
        [`${nodeTypeIndex}.${zoneDeviceFormData?.index}.${zoneDevice.description}`]: zoneDeviceFormData?.description || "",
      };
    }
    oldLANDeviceData = {};
    newLANDeviceData = {
      [nodeTypeIndex]: zoneDeviceFormData?.index,
      [`${nodeTypeIndex}.${zoneDeviceFormData?.index}.${zoneDevice.config}.${zoneDevice.priority}`]: Number(zoneDeviceFormData?.priority),
      ...bandWidth,
    };
  }

  if (operationType === OPERATIONTYPES.UPDATE && !!selectedLanDevice && !!zoneDeviceFormData) {
    Object.entries(selectedLanDevice).forEach(([oldkey, oldvalue]) => {
      Object.entries(zoneDeviceFormData).forEach(([newkey, newvalue]) => {
        if (oldkey === newkey && oldvalue !== newvalue) {
          if (oldkey === "description") {
            oldLANDeviceData = { ...oldLANDeviceData, [`${nodeTypeIndex}.${zoneDeviceFormData?.index}.${zoneDevice[oldkey]}`]: oldvalue };
            newLANDeviceData = { ...newLANDeviceData, [`${nodeTypeIndex}.${zoneDeviceFormData?.index}.${zoneDevice[newkey]}`]: newvalue };
          }
          else if(nodeType !== "SN" && oldkey === "eARFCNUL") {
            oldLANDeviceData = { ...oldLANDeviceData, [`${zoneBasePath}.${zoneDevice.ARFCNUL}`]: oldvalue };
            newLANDeviceData = { ...newLANDeviceData, [`${zoneBasePath}.${zoneDevice.ARFCNUL}`]: newvalue };
          }
          else if(nodeType !== "SN" && oldkey === "eARFCNDL") {
            oldLANDeviceData = { ...oldLANDeviceData, [`${zoneBasePath}.${zoneDevice.ARFCNDL}`]: oldvalue };
            newLANDeviceData = { ...newLANDeviceData, [`${zoneBasePath}.${zoneDevice.ARFCNDL}`]: newvalue };
          }
           else {
            oldLANDeviceData = { ...oldLANDeviceData, [`${zoneBasePath}.${zoneDevice[oldkey]}`]: oldvalue };
            newLANDeviceData = { ...newLANDeviceData, [`${zoneBasePath}.${zoneDevice[newkey]}`]: newvalue };
          }
        }
      });
    });
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: zoneDeviceFormData?.index || selectedLanDevice?.index,
    tableId: `${nodeTypeKey}.${zoneDevice.zone}.${zoneDeviceFormData?.index || selectedLanDevice?.index}`,
    deviceObjectKey: objectKey, //"22056S52746" //"16200X18393",
    oldValue: { ...oldLANDeviceData },
    newValue: { ...newLANDeviceData },
  };
};

export const prepareZoneDevicePayload1 = (
  zoneDevicesList: IZoneDevice[],
  selectedRowIDs: any[],
  objectKey: string,
  nodeType: string,
  operationType: string
) => {
  const { zoneDevice, deletepath } = xsdPathStr;
  let oldLANDeviceData = {},
    newLANDeviceData = {};
  const nodeTypeKey = `${nodeType === "SN" ? zoneDevice.lte : zoneDevice.ng}`;
  const zoneDeviceIndex = `${zoneDevice.internetGatewayDevice}.${zoneDevice.fapService}.1`;
  const nodeTypeIndex = `${zoneDeviceIndex}.${nodeTypeKey}.${zoneDevice.zone}`;
  const configEnable = `${zoneDevice.config}.${zoneDevice.ranId}.${zoneDevice.cellRestriction}.${zoneDevice.barringEmergency}`;
  const rowKeyData = zoneDevicesList[0]?.index;

  if (operationType === OPERATIONTYPES.UPDATE && zoneDevicesList?.length > 0) {
    zoneDevicesList.forEach((el, index) => {
      const elIndex = el?.index;
      oldLANDeviceData = { ...oldLANDeviceData, [`${nodeTypeIndex}.${elIndex}.${configEnable}`]: el?.barringforemergency };
      newLANDeviceData = { ...newLANDeviceData, [`${nodeTypeIndex}.${elIndex}.${configEnable}`]: !(el?.barringforemergency === "True") };
    });
  } else {
    oldLANDeviceData = {};
    newLANDeviceData = {
      [`${deletepath}`]: `${nodeTypeIndex}.${rowKeyData}.`,
    };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: rowKeyData,
    tableId: `${zoneDevice.lte}.${zoneDevice.zone}.${rowKeyData}`,
    deviceObjectKey: objectKey, //"22056S52746" //"16200X18393",
    oldValue: { ...oldLANDeviceData },
    newValue: { ...newLANDeviceData },
  };
};

export const prepareRnDrawerZonePayload = (cellListToUpdate: ICellListData, objectKey: string, nodeType: string, operationType: string) => {
  const { zoneDevice } = xsdPathStr;
  let oldLANDeviceData = {},
    newLANDeviceData = {};
  const nodeTypeKey = `${nodeType === "SN" ? zoneDevice.lte : zoneDevice.ng}`;
  const zoneDeviceIndex = `${zoneDevice.internetGatewayDevice}.${zoneDevice.fapService}.1`;
  const nodeTypeIndex = `${zoneDeviceIndex}.${nodeTypeKey}.${zoneDevice.zone}`;
  const rowKeyData = cellListToUpdate?.zoneIndex;

  if (operationType === OPERATIONTYPES.UPDATE && rowKeyData) {
    oldLANDeviceData = { ...oldLANDeviceData, [`${nodeTypeIndex}.${rowKeyData}.${zoneDevice.cellList}`]: cellListToUpdate?.oldCellList };
    newLANDeviceData = { ...newLANDeviceData, [`${nodeTypeIndex}.${rowKeyData}.${zoneDevice.cellList}`]: cellListToUpdate?.newCellList };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: rowKeyData,
    tableId: `${nodeTypeKey}.${zoneDevice.zone}.${rowKeyData}`,
    deviceObjectKey: objectKey,
    oldValue: { ...oldLANDeviceData },
    newValue: { ...newLANDeviceData },
  };
};

export const prepareSummaryPayload = (item: string, value: any, newVal: any, objectKey: any, operationType: string) => {
  const { summaryDevice } = xsdPathStr;
  const { contact, operatingMode, location, hostname, servicesNode, hostPort, latitude, longitude, description, clusterId } = summaryDevice;
  //  const sysArray = [contact, operatingMode, location];
  //  const filSystemType = sysArray.find((el) => el?.toLowerCase() === item?.toLowerCase());
  let oldSummaryData = {},
    newSummaryData = {};
  const gatewayDevice = `${summaryDevice.internetGatewayDevice}`;
  const sysGatewayDevice = `${gatewayDevice}.${summaryDevice.system}`;
  //  const updateSystemType = `${sysGatewayDevice}.${filSystemType?.split(" ")?.join("")}`;
  const updatePCILock = `${gatewayDevice}.${summaryDevice.fapService}.1.${summaryDevice.fapControl}.${summaryDevice.lte}.${summaryDevice.selfConfig}.${summaryDevice.pciLockEnabled}`;
  const updateHostname = `${gatewayDevice}.${servicesNode}.${hostPort}.${hostname}`;
  const updateLatitude = `${gatewayDevice}.${servicesNode}.${hostPort}.${location}.${latitude}`;
  const updateLongitude = `${gatewayDevice}.${servicesNode}.${hostPort}.${location}.${longitude}`;
  const updateDescription = `${sysGatewayDevice}.${description}`;
  const updateClusterId = `${clusterId}`;

  if (item?.toLowerCase() === "contact") {
    oldSummaryData = { ...oldSummaryData, [`${sysGatewayDevice}.${contact}`]: value };
    newSummaryData = { ...newSummaryData, [`${sysGatewayDevice}.${contact}`]: newVal };
  }
  if (item?.toLowerCase() === "location") {
    oldSummaryData = { ...oldSummaryData, [`${sysGatewayDevice}.${location}`]: value };
    newSummaryData = { ...newSummaryData, [`${sysGatewayDevice}.${location}`]: newVal };
  }
  if (item?.toLowerCase().replace(/\s+/g, "") === "hostname") {
    oldSummaryData = { ...oldSummaryData, [`${updateHostname}`]: value };
    newSummaryData = { ...newSummaryData, [`${updateHostname}`]: newVal };
  }
  if (item?.toLowerCase().startsWith("operating")) {
    oldSummaryData = { ...oldSummaryData, [`${sysGatewayDevice}.${operatingMode}`]: value };
    newSummaryData = { ...newSummaryData, [`${sysGatewayDevice}.${operatingMode}`]: newVal };
  }
  if (item?.toLowerCase().startsWith("pci")) {
    oldSummaryData = { ...oldSummaryData, [`${updatePCILock}`]: value };
    newSummaryData = { ...newSummaryData, [`${updatePCILock}`]: newVal };
  }
  if (item?.toLowerCase() === "latitude") {
    oldSummaryData = { ...oldSummaryData, [`${updateLatitude}`]: value };
    newSummaryData = { ...newSummaryData, [`${updateLatitude}`]: Number(newVal) };
  }
  if (item?.toLowerCase() === "longitude") {
    oldSummaryData = { ...oldSummaryData, [`${updateLongitude}`]: value };
    newSummaryData = { ...newSummaryData, [`${updateLongitude}`]: Number(newVal) };
  }
  if (item?.toLowerCase().startsWith("rcp")) {
    oldSummaryData = { ...oldSummaryData, [`${summaryDevice.rcpMode}`]: value };
    newSummaryData = { ...newSummaryData, [`${summaryDevice.rcpMode}`]: newVal };
  }
  if (item?.toLowerCase().startsWith("du")) {
    oldSummaryData = { ...oldSummaryData, [`${summaryDevice.duMode}`]: value };
    newSummaryData = { ...newSummaryData, [`${summaryDevice.duMode}`]: newVal };
  }
  if (item?.toLowerCase() === "description") {
    oldSummaryData = { ...oldSummaryData, [`${updateDescription}`]: value };
    newSummaryData = { ...newSummaryData, [`${updateDescription}`]: newVal };
  }
  if (item?.toLowerCase().startsWith("cluster")) {
    oldSummaryData = { ...oldSummaryData, [`${updateClusterId}`]: value };
    newSummaryData = { ...newSummaryData, [`${updateClusterId}`]: newVal };
  }
  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: "",
    tableId: "",
    deviceObjectKey: objectKey, //"22056S52746" //"16200X18393",
    oldValue: { ...oldSummaryData },
    newValue: { ...newSummaryData },
  };
};

export const prepareEnablePortPayload = (newObj: any, enableVal: any, localPort: any, objectKey: any, operationType: string, nodeType: string) => {
  const { summaryDevice } = xsdPathStr;
  const { ngPeerBasePath, ltePeerBasePath } = summaryDevice;
  let oldSummaryData = {},
    newSummaryData = {};
  const updateConnection = nodeType === "SN" ? `${ltePeerBasePath}` : `${ngPeerBasePath}`;
  if (newObj?.hasOwnProperty("LocalPort")) {
    oldSummaryData = { ...oldSummaryData, [`${updateConnection}.LocalPort`]: localPort };
    newSummaryData = { ...newSummaryData, [`${updateConnection}.LocalPort`]: newObj?.LocalPort };
  }
  if (newObj?.hasOwnProperty("Enable")) {
    oldSummaryData = { ...oldSummaryData, [`${updateConnection}.Enable`]: enableVal };
    newSummaryData = { ...newSummaryData, [`${updateConnection}.Enable`]: newObj?.Enable };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: "",
    tableId: "",
    deviceObjectKey: objectKey, //"22056S52746" //"16200X18393",
    oldValue: { ...oldSummaryData },
    newValue: { ...newSummaryData },
  };
};

export const ipInterfaceIndexes = (ipInterfaceData: Array<IIPInterface>) =>
  ipInterfaceData.length > 0 && ipInterfaceData.map((item) => Object.keys(item).map((keyitem) => keyitem === "index") && Number(item.index));

export const getNextLANDeviceIndex = (dataArray: Array<string>, max: number) => {
  const missingIndexes = Array.from(Array(max), (v, i) => i + 1).filter((i) => !dataArray?.includes(i.toString()));
  const nextLanDeviceIndex = Math.min(...missingIndexes).toString();
  return nextLanDeviceIndex;
};

export const getNextIPInterfaceIndex = (dataArray: Array<IIPInterface>) => {
  const IPIndexes = ipInterfaceIndexes(dataArray);
  let [max, min] = !!IPIndexes ? [Math.max(...IPIndexes), Math.min(...IPIndexes)] : [0, 1];
  let nextIPIndex: number;
  const missingIndexes = Array.from(Array(max - min), (v, i) => i + 1).filter((i) => !!IPIndexes && !IPIndexes?.includes(i));
  if (missingIndexes && missingIndexes.length <= 0) {
    nextIPIndex = max + 1;
  } else {
    nextIPIndex = Math.min(...missingIndexes);
  }
  return nextIPIndex.toString();
};

export const getNextRfFeedIndex = (dataArray: Array<string>, max: number) => {
  const missingIndexes = Array.from(Array(max), (v, i) => i + 1).filter((i) => !dataArray?.includes(i.toString()));
  const nextRfFeedIndex = Math.min(...missingIndexes).toString();
  return nextRfFeedIndex;
};

export const getNextZoneDeviceIndex = (dataArray: Array<string>, max: number) => {
  return dataArray?.length + 1;
};

export const prepareIPInterfacePayload = (
  newIPInterface: IIPInterface | undefined,
  oldIPInterface: IIPInterface,
  objectKey: string,
  operationType: string
) => {
  const { lanDevice, ipInterface, deletepath } = xsdPathStr;
  const ipInterfaceIndexe = operationType === OPERATIONTYPES.CREATE ? newIPInterface?.index : oldIPInterface.index;
  const vlanId = operationType === OPERATIONTYPES.CREATE ? newIPInterface?.vlanId : oldIPInterface.vlanId;
  const ipInterfaceKey = `${lanDevice.internetGatewayDevice}.${lanDevice.lanDevice}.${vlanId}.${ipInterface.lanHostConfigManagement}`;

  let oldIPInterfaceData = {},
    newIPInterfaceData = {};

  const omitObjKey = ["stats", "operState", "index"];
  if (operationType === OPERATIONTYPES.UPDATE && !!oldIPInterface && !!newIPInterface) {
    Object.entries(oldIPInterface).forEach(([oldkey, oldvalue]) => {
      Object.entries(newIPInterface).forEach(([newkey, newvalue]) => {
        if (oldkey === newkey && oldvalue !== newvalue && !omitObjKey.includes(oldkey)) {
          oldIPInterfaceData = { ...oldIPInterfaceData, [`${ipInterfaceKey}.${ipInterfaceIndexe}.${ipInterface[oldkey]}`]: oldvalue };
          newIPInterfaceData = { ...newIPInterfaceData, [`${ipInterfaceKey}.${ipInterfaceIndexe}.${ipInterface[newkey]}`]: newvalue };
        }
      });
    });
    //newIPInterfaceData = { ...newIPInterfaceData, [ipInterfaceKey]: ipInterfaceIndexe };
  } else if (operationType === OPERATIONTYPES.CREATE && !!newIPInterface) {
    oldIPInterfaceData = {};
    Object.entries(newIPInterface).forEach(([newkey, newvalue]) => {
      if (!omitObjKey.includes(newkey)) {
        newIPInterfaceData = { ...newIPInterfaceData, [`${ipInterfaceKey}.${ipInterfaceIndexe}.${ipInterface[newkey]}`]: newvalue };
      }
    });
    newIPInterfaceData = { ...newIPInterfaceData, [ipInterfaceKey]: ipInterfaceIndexe };
  } else if (operationType === OPERATIONTYPES.DELETE && !!oldIPInterface) {
    oldIPInterfaceData = {};
    newIPInterfaceData = {
      [`${deletepath}`]: `${ipInterfaceKey}.${ipInterfaceIndexe}.`,
    };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: newIPInterface?.vlanId || oldIPInterface.vlanId,
    tableId: `${lanDevice.tableId}.${newIPInterface?.vlanId || oldIPInterface.vlanId}.${ipInterface.tableId}.${ipInterfaceIndexe}`,
    deviceObjectKey: objectKey, //"22056S52746" //"16200X18393",
    oldValue: { ...oldIPInterfaceData },
    newValue: { ...newIPInterfaceData },
  };
};

export const prepareRfFeedPayload = (
  rfFeedFormData: IRfFeed | undefined,
  selectedRfFeed: IRfFeed | undefined,
  objectKey: string,
  operationType: string
) => {
  const { rfFeed, deletepath } = xsdPathStr;
  const rfFeedIndex = `${rfFeed.internetGatewayDevice}.${rfFeed.rfFeed}`;
  const rfFeedIndexPath = `${rfFeed.internetGatewayDevice}.${rfFeed.rfFeed}.${rfFeedFormData?.index}`;
  let oldRfFeedData = {},
    newRfFeedData = {};

  if (operationType === OPERATIONTYPES.UPDATE && !!selectedRfFeed && !!rfFeedFormData) {
    Object.entries(selectedRfFeed).forEach(([oldkey, oldvalue]) => {
      Object.entries(rfFeedFormData).forEach(([newkey, newvalue]) => {
        if (oldkey === newkey && oldvalue !== newvalue) {
          oldRfFeedData = { ...oldRfFeedData, [`${rfFeedIndexPath}.${rfFeed[oldkey]}`]: oldvalue };
          newRfFeedData = { ...newRfFeedData, [`${rfFeedIndexPath}.${rfFeed[newkey]}`]: newvalue };
        }
      });
    });
  } else if (operationType === OPERATIONTYPES.DELETE && !!selectedRfFeed) {
    oldRfFeedData = {};
    newRfFeedData = {
      [`${deletepath}`]: `${rfFeedIndex}.${selectedRfFeed.index}.`,
    };
  } else {
    oldRfFeedData = {};
    newRfFeedData = {
      [rfFeedIndex]: rfFeedFormData?.index,
      [`${rfFeedIndexPath}.${rfFeed.type}`]: rfFeedFormData?.type,
      [`${rfFeedIndexPath}.${rfFeed.dlarfcn}`]: rfFeedFormData?.dlarfcn,
      [`${rfFeedIndexPath}.${rfFeed.ularfcn}`]: rfFeedFormData?.ularfcn,
      [`${rfFeedIndexPath}.${rfFeed.dlBandwidth}`]: rfFeedFormData?.dlBandwidth,
      [`${rfFeedIndexPath}.${rfFeed.ulBandwidth}`]: rfFeedFormData?.ulBandwidth,
      //[`${rfFeedIndexPath}.${rfFeed.dlAttenuation}`]: rfFeedFormData?.dlAttenuation,
    };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: rfFeedFormData?.index || selectedRfFeed?.index,
    tableId: `${rfFeed.tableId}.${rfFeedFormData?.index || selectedRfFeed?.index}`,
    deviceObjectKey: objectKey, //"22056S52746" //"16200X18393",
    oldValue: { ...oldRfFeedData },
    newValue: { ...newRfFeedData },
  };
};

export const prepareconnectRfFeedPayload = (connectRfFeedFormData: IRfFeedToRim | undefined, objectKey: string, operationType: string) => {
  const { connectRfFeed } = xsdPathStr;
  //  const radioUnitPath = `${connectRfFeed.internetGatewayDevice}.${connectRfFeed.radioUnit}`;
  const radioUnitIndexPath = `${connectRfFeed.internetGatewayDevice}.${connectRfFeed.radioUnit}.${connectRfFeedFormData?.radioUnitIndex}`;
  const radioInputModulePath = `${radioUnitIndexPath}.${connectRfFeed.radioInputModule}`;
  const radioInputModuleIndexPath1 = `${radioInputModulePath}.${connectRfFeedFormData?.radioInputModuleId1}`;
  const radioInputModuleIndexPath2 = `${radioInputModulePath}.${connectRfFeedFormData?.radioInputModuleId2}`;

  let oldconnectRfFeedData = {},
    newconnectRfFeedData = {};

  if (operationType === OPERATIONTYPES.UPDATE && !!connectRfFeedFormData) {
    newconnectRfFeedData = {
      [`${radioInputModuleIndexPath1}.${connectRfFeed.rfFeedIndex}`]: connectRfFeedFormData?.rfFeedIndex,
      [`${radioInputModuleIndexPath2}.${connectRfFeed.rfFeedIndex}`]: connectRfFeedFormData?.rfFeedIndex,
      [`${radioInputModuleIndexPath1}.${connectRfFeed.enable}`]: connectRfFeedFormData?.radioInputModuleId1Enable,
      [`${radioInputModuleIndexPath2}.${connectRfFeed.enable}`]: connectRfFeedFormData?.radioInputModuleId2Enable,
    };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: "",
    tableId: "",
    deviceObjectKey: objectKey,
    oldValue: { ...oldconnectRfFeedData },
    newValue: { ...newconnectRfFeedData },
  };
};

export const prepareRfFeedLatestPayload = (
  rfFeedFormData: IRfFeed | undefined,
  selectedRfFeed: IRfFeed | undefined,
  objectKey: string,
  operationType: string
) => {
  const { rfFeed, deletepath } = xsdPathStr;
  const rfFeedIndex = `${rfFeed.internetGatewayDevice}.${rfFeed.rfFeed}`;
  const rfFeedIndexPath = `${rfFeed.internetGatewayDevice}.${rfFeed.rfFeed}.${rfFeedFormData?.index}`;
  let oldRfFeedData = {},
    newRfFeedData = {};

  if (operationType === OPERATIONTYPES.UPDATE && !!selectedRfFeed && !!rfFeedFormData) {
    Object.entries(selectedRfFeed).forEach(([oldkey, oldvalue]) => {
      Object.entries(rfFeedFormData).forEach(([newkey, newvalue]) => {
        if (oldkey === newkey && oldvalue !== newvalue) {
          if (oldkey === "ularfcn" || oldkey === "dlarfcn" || oldkey === "dlBandwidth" || oldkey === "ulBandwidth") {
            oldRfFeedData = { ...oldRfFeedData, [`${rfFeedIndexPath}.RF.${rfFeed[oldkey]}`]: oldvalue };
            newRfFeedData = { ...newRfFeedData, [`${rfFeedIndexPath}.RF.${rfFeed[newkey]}`]: newvalue };
          } else {
            oldRfFeedData = { ...oldRfFeedData, [`${rfFeedIndexPath}.${rfFeed[oldkey]}`]: oldvalue };
            newRfFeedData = { ...newRfFeedData, [`${rfFeedIndexPath}.${rfFeed[newkey]}`]: newvalue };
          }
        }
      });
    });
  } else if (operationType === OPERATIONTYPES.DELETE && !!selectedRfFeed) {
    oldRfFeedData = {};
    newRfFeedData = {
      [`${deletepath}`]: `${rfFeedIndex}.${selectedRfFeed.index}.`,
    };
  } else {
    oldRfFeedData = {};
    newRfFeedData = {
      [rfFeedIndex]: rfFeedFormData?.index,
      [`${rfFeedIndexPath}.${rfFeed.type}`]: rfFeedFormData?.type,
      [`${rfFeedIndexPath}.RF.${rfFeed.dlarfcn}`]: rfFeedFormData?.dlarfcn,
      [`${rfFeedIndexPath}.RF.${rfFeed.ularfcn}`]: rfFeedFormData?.ularfcn,
      [`${rfFeedIndexPath}.RF.${rfFeed.dlBandwidth}`]: rfFeedFormData?.dlBandwidth,
      [`${rfFeedIndexPath}.RF.${rfFeed.ulBandwidth}`]: rfFeedFormData?.ulBandwidth,
      //[`${rfFeedIndexPath}.${rfFeed.dlAttenuation}`]: rfFeedFormData?.dlAttenuation,
    };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: rfFeedFormData?.index || selectedRfFeed?.index,
    tableId: `${rfFeed.tableId}.${rfFeedFormData?.index || selectedRfFeed?.index}`,
    deviceObjectKey: objectKey, //"22056S52746" //"16200X18393",
    oldValue: { ...oldRfFeedData },
    newValue: { ...newRfFeedData },
  };
};

export const getNextLteX2ConnectionIndex = (dataArray: Array<string>, max: number) => {
  const missingIndexes = Array.from(Array(max), (v, i) => i + 1).filter((i) => !dataArray?.includes(i.toString()));
  const nextLteX2ConnectionIndex = Math.min(...missingIndexes).toString();
  return nextLteX2ConnectionIndex;
};

export const prepareLteX2ConnectionPayload = (
  lteX2ConnectionPeerFormData: IltepeerInterfaces | undefined,
  selectedlteX2ConnectionPeer: IltepeerInterfaces | undefined,
  objectKey: string,
  operationType: string
) => {
  const { lteX2ConnectionPeer, deletepath } = xsdPathStr;
  const lteX2PeerBasePath = `${lteX2ConnectionPeer.ltePeerBasePath}`;
  const lteX2PeerIndexPath = `${lteX2PeerBasePath}.${lteX2ConnectionPeerFormData?.index}`;
  let oldLteX2PeerData = {},
    newLteX2PeerData = {};

  if (operationType === OPERATIONTYPES.UPDATE && !!selectedlteX2ConnectionPeer && !!lteX2ConnectionPeerFormData) {
    Object.entries(selectedlteX2ConnectionPeer).forEach(([oldkey, oldvalue]) => {
      Object.entries(lteX2ConnectionPeerFormData).forEach(([newkey, newvalue]) => {
        if (oldkey === newkey && oldvalue !== newvalue) {
          oldLteX2PeerData = { ...oldLteX2PeerData, [`${lteX2PeerIndexPath}.${lteX2ConnectionPeer[oldkey]}`]: oldvalue };
          newLteX2PeerData = { ...newLteX2PeerData, [`${lteX2PeerIndexPath}.${lteX2ConnectionPeer[newkey]}`]: newvalue };
        }
      });
    });
  } else if (operationType === OPERATIONTYPES.DELETE && !!selectedlteX2ConnectionPeer) {
    oldLteX2PeerData = {};
    newLteX2PeerData = {
      [`${deletepath}`]: `${lteX2PeerBasePath}.${selectedlteX2ConnectionPeer.index}.`,
    };
  } else {
    oldLteX2PeerData = {};
    newLteX2PeerData = {
      [lteX2PeerBasePath]: lteX2ConnectionPeerFormData?.index,
      [`${lteX2PeerIndexPath}.${lteX2ConnectionPeer.enable}`]: lteX2ConnectionPeerFormData?.enable,
      [`${lteX2PeerIndexPath}.${lteX2ConnectionPeer.name}`]: lteX2ConnectionPeerFormData?.name,
      [`${lteX2PeerIndexPath}.${lteX2ConnectionPeer.address}`]: lteX2ConnectionPeerFormData?.address,
      // [`${lteX2PeerIndexPath}.${lteX2ConnectionPeer.connectionState}`]: lteX2ConnectionPeerFormData?.connectionState,
      //[`${lteX2PeerIndexPath}.${lteX2ConnectionPeer.localAddress}`]: lteX2ConnectionPeerFormData?.localAddress,
      [`${lteX2PeerIndexPath}.${lteX2ConnectionPeer.plmnId}`]: lteX2ConnectionPeerFormData?.plmnId,
      [`${lteX2PeerIndexPath}.${lteX2ConnectionPeer.port}`]: lteX2ConnectionPeerFormData?.port,
      [`${lteX2PeerIndexPath}.${lteX2ConnectionPeer.tac}`]: lteX2ConnectionPeerFormData?.tac,
      [`${lteX2PeerIndexPath}.${lteX2ConnectionPeer.type}`]: lteX2ConnectionPeerFormData?.type,
      [`${lteX2PeerIndexPath}.${lteX2ConnectionPeer.eNodeBID}`]: lteX2ConnectionPeerFormData?.eNodeBID,
      [`${lteX2PeerIndexPath}.${lteX2ConnectionPeer.gNodeBID}`]: lteX2ConnectionPeerFormData?.gNodeBID,
      // [`${lteX2PeerIndexPath}.${lteX2ConnectionPeer.remoteAddress}`]: lteX2ConnectionPeerFormData?.remoteAddress,
      // [`${lteX2PeerIndexPath}.${lteX2ConnectionPeer.connectionId}`]: lteX2ConnectionPeerFormData?.connectionId,
      [`${lteX2PeerIndexPath}.${lteX2ConnectionPeer.isENDCX2}`]: lteX2ConnectionPeerFormData?.isENDCX2,
    };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: lteX2ConnectionPeerFormData?.index || selectedlteX2ConnectionPeer?.index,
    tableId: `${lteX2ConnectionPeer.tableId}.${lteX2ConnectionPeerFormData?.index || selectedlteX2ConnectionPeer?.index}`,
    deviceObjectKey: objectKey,
    oldValue: { ...oldLteX2PeerData },
    newValue: { ...newLteX2PeerData },
  };
};

export const getNextNgX2ConnectionIndex = (dataArray: Array<string>, max: number) => {
  const missingIndexes = Array.from(Array(max), (v, i) => i + 1).filter((i) => !dataArray?.includes(i.toString()));
  const nextLteX2ConnectionIndex = Math.min(...missingIndexes).toString();
  return nextLteX2ConnectionIndex;
};

export const prepareNgX2ConnectionPayload = (
  ngX2ConnectionPeerFormData: IngpeerInterfaces | undefined,
  selectedNgX2ConnectionPeer: IngpeerInterfaces | undefined,
  objectKey: string,
  operationType: string
) => {
  const { ngX2ConnectionPeer, deletepath } = xsdPathStr;
  const ngX2PeerBasePath = `${ngX2ConnectionPeer.ltePeerBasePath}`;
  const ngX2PeerIndexPath = `${ngX2PeerBasePath}.${ngX2ConnectionPeerFormData?.index}`;
  let oldNgX2PeerData = {},
    newNgX2PeerData = {};

  if (operationType === OPERATIONTYPES.UPDATE && !!selectedNgX2ConnectionPeer && !!ngX2ConnectionPeerFormData) {
    Object.entries(selectedNgX2ConnectionPeer).forEach(([oldkey, oldvalue]) => {
      Object.entries(ngX2ConnectionPeerFormData).forEach(([newkey, newvalue]) => {
        if (oldkey === newkey && oldvalue !== newvalue) {
          oldNgX2PeerData = { ...oldNgX2PeerData, [`${ngX2PeerIndexPath}.${ngX2ConnectionPeer[oldkey]}`]: oldvalue };
          newNgX2PeerData = { ...newNgX2PeerData, [`${ngX2PeerIndexPath}.${ngX2ConnectionPeer[newkey]}`]: newvalue };
        }
      });
    });
  } else if (operationType === OPERATIONTYPES.DELETE && !!selectedNgX2ConnectionPeer) {
    oldNgX2PeerData = {};
    newNgX2PeerData = {
      [`${deletepath}`]: `${ngX2PeerBasePath}.${selectedNgX2ConnectionPeer.index}.`,
    };
  } else {
    oldNgX2PeerData = {};
    newNgX2PeerData = {
      [ngX2PeerBasePath]: ngX2ConnectionPeerFormData?.index,
      [`${ngX2PeerIndexPath}.${ngX2ConnectionPeer.enable}`]: ngX2ConnectionPeerFormData?.enable,
      [`${ngX2PeerIndexPath}.${ngX2ConnectionPeer.name}`]: ngX2ConnectionPeerFormData?.name,
      [`${ngX2PeerIndexPath}.${ngX2ConnectionPeer.address}`]: ngX2ConnectionPeerFormData?.address,
      //[`${ngX2PeerIndexPath}.${ngX2ConnectionPeer.connectionState}`]: ngX2ConnectionPeerFormData?.connectionState,
      //[`${ngX2PeerIndexPath}.${ngX2ConnectionPeer.localAddress}`]: ngX2ConnectionPeerFormData?.localAddress,
      [`${ngX2PeerIndexPath}.${ngX2ConnectionPeer.plmnId}`]: ngX2ConnectionPeerFormData?.plmnId,
      [`${ngX2PeerIndexPath}.${ngX2ConnectionPeer.port}`]: ngX2ConnectionPeerFormData?.port,
      [`${ngX2PeerIndexPath}.${ngX2ConnectionPeer.eNodeBID}`]: ngX2ConnectionPeerFormData?.eNodeBID,
      //[`${ngX2PeerIndexPath}.${ngX2ConnectionPeer.remoteAddress}`]: ngX2ConnectionPeerFormData?.remoteAddress,
      //[`${ngX2PeerIndexPath}.${ngX2ConnectionPeer.connectionId}`]: ngX2ConnectionPeerFormData?.connectionId,
    };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: ngX2ConnectionPeerFormData?.index || selectedNgX2ConnectionPeer?.index,
    tableId: `${ngX2ConnectionPeer.tableId}.${ngX2ConnectionPeerFormData?.index || selectedNgX2ConnectionPeer?.index}`,
    deviceObjectKey: objectKey,
    oldValue: { ...oldNgX2PeerData },
    newValue: { ...newNgX2PeerData },
  };
};

export const prepareRadioNodePayload = (
  selectedRadioNode: IRadioNodesDataGridRow | undefined,
  objectKey: string | undefined,
  operationType: string,
  provisionIndex: number
) => {
  const { radioNode, deletepath } = xsdPathStr;
  const radioNodeBasePath = `${radioNode.radioNodeBasePath}`;
  //  const radioNodeIndexPath = `${radioNodeBasePath}.${selectedRadioNode?.id}`;
  let oldRnData = {},
    newRnData = {};

  if (operationType === OPERATIONTYPES.DELETE && !!selectedRadioNode) {
    oldRnData = {};
    newRnData = {
      [`${deletepath}`]: `${radioNodeBasePath}.${selectedRadioNode?.id}.`,
    };
  }

  if (operationType === OPERATIONTYPES.CREATE && !!selectedRadioNode) {
    oldRnData = {};
    newRnData = {
      [`${radioNodeBasePath}`]: provisionIndex,
      [`${radioNodeBasePath}.${provisionIndex}.${radioNode.ethernetId}`]: selectedRadioNode?.ethernetId,
    };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: operationType === OPERATIONTYPES.CREATE ? provisionIndex : selectedRadioNode?.id,
    tableId: `${radioNode.tableId}.${operationType === OPERATIONTYPES.CREATE ? provisionIndex : selectedRadioNode?.id}`,
    deviceObjectKey: objectKey,
    oldValue: { ...oldRnData },
    newValue: { ...newRnData },
  };
};

export const prepareRadioNodeProvisionPayload = (
  selectedRadioNode: IRadioNodesDataGridRow | undefined,
  objectKey: string | undefined,
  operationType: string,
  provisionIndex: number,
  radioAddUpdate: IRadioListBandData[],
  cellAddUpdate: ICellsConfigData,
  nodeType: string
) => {
  const { radioNode, deletepath } = xsdPathStr;
  const radioNodeBasePath = `${radioNode.radioNodeBasePath}`;
  const radioNodeIndexPath = `${radioNodeBasePath}.${provisionIndex}`;
  const isMmWType = cellAddUpdate?.isMmwType;
  const radioCellPci = isMmWType ? `${radioNode.nrCellConfig}.${radioNode.cellPci}` : `${radioNode.lteCellConfig}.${radioNode.cellPci}`;
  const radioCellPower = isMmWType ? `${radioNode.nrCellConfig}.${radioNode.power}` : `${radioNode.lteCellConfig}.${radioNode.power}`;
  const radioCellBasePath = isMmWType ? `${radioNode.nrCellBasePath}` : `${radioNode.lteCellBasePath}`;
  const radioCellCommonPath = `${radioNode.cellConfig}.${isMmWType ? radioNode.ng : radioNode.lte}.${radioNode.ran}.${radioNode.common}.${
    radioNode.cellId
  }`;
  const radioCellModePath = `${radioNode.cellConfig}.${isMmWType ? radioNode.ng : radioNode.lte}.${radioNode.ran}.${radioNode.rf}.${radioNode.mode}`;
  let oldRnData = {},
    newRnData = {};

  if (operationType === OPERATIONTYPES.DELETE && !!selectedRadioNode) {
    oldRnData = {};
    newRnData = {
      [`${deletepath}`]: `${radioNodeBasePath}.${selectedRadioNode?.id}.`,
    };
  }

  if (operationType === OPERATIONTYPES.CREATE && !!selectedRadioNode) {
    oldRnData = {};
    newRnData = {
      [`${radioNodeBasePath}`]: provisionIndex,
      [`${radioNodeBasePath}.${provisionIndex}.${radioNode.ethernetId}`]: selectedRadioNode?.ethernetId,
      [`${radioNodeBasePath}.${provisionIndex}.${radioNode.nodeType}`]: selectedRadioNode?.nodeType,
      [`${radioNodeBasePath}.${provisionIndex}.${radioNode.enable}`]: "true",
      [`${radioNodeBasePath}.${provisionIndex}.${radioNode.name}`]: selectedRadioNode?.name,
      [`${radioNodeBasePath}.${provisionIndex}.${radioNode.cellDescription}`]: selectedRadioNode?.description,
    };
    if (radioAddUpdate?.length > 0) {
      const updatedObj = radioAddUpdate?.reduce((result: IKeyValue, el: IRadioListBandData) => {
        let radioIndex = el?.radio?.toString();
        let obj: IKeyValue = {
          [`${radioNodeIndexPath}.${radioNode.radio}.${radioIndex}.${radioNode.band}`]: el?.newBandData || "",
          [`${radioNodeIndexPath}.${radioNode.radio}.${radioIndex}.${radioNode.enable}`]: "true",
        };
        return { ...result, ...obj };
      }, {});
      newRnData = { ...newRnData, ...updatedObj };
    }
    if (Array.isArray(cellAddUpdate?.cellLists) && cellAddUpdate?.cellLists?.length > 0) {
      const updatedCellObj = cellAddUpdate?.cellLists?.reduce((result: any, el: ICellListPayload) => {
        let radioIndex = el?.radioIndex?.toString();
        let cellFormData = el?.cellData;
        let obj = {
          [`${radioCellBasePath}`]: cellFormData?.cellId,
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioCellCommonPath}`]: cellFormData?.commonCellId,
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.radioNode}`]: provisionIndex,
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.cellDescription}`]: cellFormData?.cellDescription,
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.enable}`]: "true",
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioCellPci}`]: cellFormData?.cellPci?.toString(),
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.radio}`]: radioIndex?.toString(),
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.cellName}`]: cellFormData?.cellName,
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioCellPower}`]: cellFormData?.power?.toString(),
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioCellModePath}`]: "LTENetmon",
        };
        return { ...result, ...obj };
      }, {});
      newRnData = { ...newRnData, ...updatedCellObj };
    }
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: operationType === OPERATIONTYPES.CREATE ? provisionIndex : selectedRadioNode?.id,
    tableId: `${radioNode.tableId}.${operationType === OPERATIONTYPES.CREATE ? provisionIndex : selectedRadioNode?.id}`,
    deviceObjectKey: objectKey,
    oldValue: { ...oldRnData },
    newValue: { ...newRnData },
  };
};

export const prepareRnCuDuProvisionPayload = (
  selectedRadioNode: IRadioNodesDataGridRow | undefined,
  objectKey: string | undefined,
  operationType: string,
  provisionIndex: number,
  radioAddUpdate: IRadioListBandData[],
  cellAddUpdate: ICellsCuConfigData,
  version: string
) => {
  const { radioNode, nrCellNode, deletepath } = xsdPathStr;
  const radioNodeBasePath = `${radioNode.radioNodeBasePath}`;
  const radioNodeIndexPath = `${radioNodeBasePath}.${provisionIndex}`;
  const radioCellPci = `${radioNode.nrCellConfig}.${radioNode.cellPci}`;
  const radioCellBasePath = `${radioNode.nrCellBasePath}`;
  const radioCellCommonPath = `${radioNode.cellConfig}.${nrCellNode.ng}.${radioNode.ran}.${radioNode.common}.${radioNode.cellId}`;
  let oldRnData = {},
    newRnData = {};

  if (operationType === OPERATIONTYPES.DELETE && !!selectedRadioNode) {
    oldRnData = {};
    newRnData = {
      [`${deletepath}`]: `${radioNodeBasePath}.${selectedRadioNode?.id}.`,
    };
  }

  if (operationType === OPERATIONTYPES.CREATE && !!selectedRadioNode) {
    oldRnData = {};
    newRnData = {
      [`${radioNodeBasePath}`]: provisionIndex,
      [`${radioNodeBasePath}.${provisionIndex}.${radioNode.ethernetId}`]: selectedRadioNode?.ethernetId,
      [`${radioNodeBasePath}.${provisionIndex}.${radioNode.nodeType}`]: selectedRadioNode?.nodeType,
      [`${radioNodeBasePath}.${provisionIndex}.${radioNode.enable}`]: "true",
    };
    if (radioAddUpdate?.length > 0) {
      const updatedObj = radioAddUpdate?.reduce((result: IKeyValue, el: IRadioListBandData) => {
        let radioIndex = el?.radio?.toString();
        let obj: IKeyValue = {
          [`${radioNodeIndexPath}.${radioNode.radio}.${radioIndex}.${radioNode.band}`]: el?.newBandData || "",
          [`${radioNodeIndexPath}.${radioNode.radio}.${radioIndex}.${radioNode.enable}`]: "true",
        };
        return { ...result, ...obj };
      }, {});
      newRnData = { ...newRnData, ...updatedObj };
    }
    if (Array.isArray(cellAddUpdate?.cellLists) && cellAddUpdate?.cellLists?.length > 0) {
      const updatedCellObj = cellAddUpdate?.cellLists?.reduce((result: any, el: ICellCuListPayload) => {
        let radioIndex = el?.radioIndex?.toString();
        let cellFormData = el?.cellData;
        let obj = {
          [`${radioCellBasePath}`]: cellFormData?.cellId,
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioCellCommonPath}`]: cellFormData?.commonCellId,
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.radioNode}`]: provisionIndex,
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.cellDescription}`]: cellFormData?.cellDescription,
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.enable}`]: "true",
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioCellPci}`]: cellFormData?.cellPci?.toString(),
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.radio}`]: radioIndex?.toString(),
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.cellName}`]: cellFormData?.cellName,
          ...(parseFloat(version) >= 23.4
            ? { [`${radioCellBasePath}.${cellFormData?.cellId}.${nrCellNode.txPower}`]: cellFormData?.txPower }
            : { [`${radioCellBasePath}.${cellFormData?.cellId}.${nrCellNode.pbchPower}`]: cellFormData?.pbchPower }),
        };
        return { ...result, ...obj };
      }, {});
      newRnData = { ...newRnData, ...updatedCellObj };
    }
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: operationType === OPERATIONTYPES.CREATE ? provisionIndex : selectedRadioNode?.id,
    tableId: `${radioNode.tableId}.${operationType === OPERATIONTYPES.CREATE ? provisionIndex : selectedRadioNode?.id}`,
    deviceObjectKey: objectKey,
    oldValue: { ...oldRnData },
    newValue: { ...newRnData },
  };
};

export const prepareRadioPayload = (
  selectedRadioNode: IRadioNodesDataGridRow | undefined,
  oldBandData: string,
  objectKey: string | undefined,
  selectedRadio: string,
  operationType: string,
  selectedBandVal: string
) => {
  const { radioNode, deletepath } = xsdPathStr;
  const radioNodeBasePath = `${radioNode.radioNodeBasePath}`;
  const radioNodeIndexPath = `${radioNodeBasePath}.${selectedRadioNode?.id}`;
  const radioIndex = selectedRadio === "radio1" ? 1 : 2;

  let oldRnData = {},
    newRnData = {};

  if (operationType === OPERATIONTYPES.DELETE && !!selectedRadioNode) {
    oldRnData = {};
    newRnData = {
      [`${deletepath}`]: `${radioNodeBasePath}.${selectedRadioNode?.id}.`,
    };
  }

  if (operationType === OPERATIONTYPES.CREATE && !!selectedRadioNode) {
    oldRnData = {};
    newRnData = {
      [`${radioNodeIndexPath}.${radioNode.radio}`]: radioIndex.toString(),
      [`${radioNodeIndexPath}.${radioNode.radio}.${radioIndex}.${radioNode.band}`]: selectedBandVal || "",
      [`${radioNodeIndexPath}.${radioNode.radio}.${radioIndex}.${radioNode.enable}`]: "true",
    };
  }

  if (operationType === OPERATIONTYPES.UPDATE && !!selectedRadioNode) {
    oldRnData = {
      [`${radioNodeIndexPath}.${radioNode.radio}.${radioIndex}.${radioNode.band}`]: oldBandData || "",
    };
    newRnData = {
      [`${radioNodeIndexPath}.${radioNode.radio}.${radioIndex}.${radioNode.band}`]: selectedBandVal || "",
    };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: selectedRadioNode?.id,
    tableId: `${radioNode.tableId}.${selectedRadioNode?.id}`,
    deviceObjectKey: objectKey,
    oldValue: { ...oldRnData },
    newValue: { ...newRnData },
  };
};

export const prepareDistributedNodePayload = (
  selectedRadioNode: IDusNodeDataGridRow | undefined,
  objectKey: string | undefined,
  operationType: string,
  provisionIndex: number
) => {
  const { radioNode, deletepath } = xsdPathStr;
  const radioNodeBasePath = `${radioNode.radioNodeBasePath}`;
  //  const radioNodeIndexPath = `${radioNodeBasePath}.${selectedRadioNode?.id}`;
  let oldRnData = {},
    newRnData = {};

  if (operationType === OPERATIONTYPES.DELETE && !!selectedRadioNode) {
    oldRnData = {};
    newRnData = {
      [`${deletepath}`]: `${radioNodeBasePath}.${selectedRadioNode?.id}.`,
    };
  }

  if (operationType === OPERATIONTYPES.CREATE && !!selectedRadioNode) {
    oldRnData = {};
    newRnData = {
      [`${radioNodeBasePath}`]: provisionIndex,
      [`${radioNodeBasePath}.${provisionIndex}.${radioNode.ethernetId}`]: selectedRadioNode?.ethernetId,
      [`${radioNodeBasePath}.${provisionIndex}.${radioNode.nodeType}`]: selectedRadioNode?.nodeType,
    };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: operationType === OPERATIONTYPES.CREATE ? provisionIndex : selectedRadioNode?.id,
    tableId: `${radioNode.tableId}.${operationType === OPERATIONTYPES.CREATE ? provisionIndex : selectedRadioNode?.id}`,
    deviceObjectKey: objectKey,
    oldValue: { ...oldRnData },
    newValue: { ...newRnData },
  };
};

export const prepareSectorProvisionPayload = (
  selectedRadioNode: IDusNodeDataGridRow | undefined,
  objectKey: string | undefined,
  operationType: string,
  sectorFormData: ISectorProvision
) => {
  const { radioNode } = xsdPathStr;
  const radioUnitBasePath = `${radioNode.radioUnitBasePath}`;
  let oldRnData = {},
    newRnData = {};

  if (operationType === OPERATIONTYPES.CREATE) {
    oldRnData = {};
    newRnData = {
      [`${radioUnitBasePath}`]: sectorFormData?.index,
      [`${radioUnitBasePath}.${sectorFormData?.index}.${radioNode.ethernetId}`]: sectorFormData?.ethernetId,
      [`${radioUnitBasePath}.${sectorFormData?.index}.${radioNode.radioNodeIndex}`]: sectorFormData?.radioNodeIndex,
      [`${radioUnitBasePath}.${sectorFormData?.index}.${radioNode.name}`]: sectorFormData?.name,
    };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: sectorFormData?.index,
    tableId: `${radioNode.radioUnit}.${sectorFormData?.index}`,
    deviceObjectKey: objectKey,
    oldValue: { ...oldRnData },
    newValue: { ...newRnData },
  };
};

export const prepareDuSectorHubProvisionPayload = (
  selectedRadioNode: IDusNodeDataGridRow | undefined,
  objectKey: string | undefined,
  operationType: string,
  provisionIndex: number,
  radioAddUpdate: IRadioListBandData[],
  cellAddUpdate: ICellsCuConfigData,
  version: string,
  sectorHubPayload: ISectorProvision[]
) => {
  const { radioNode, nrCellNode, deletepath } = xsdPathStr;
  const radioNodeBasePath = `${radioNode.radioNodeBasePath}`;
  const radioNodeIndexPath = `${radioNodeBasePath}.${provisionIndex}`;
  const radioCellPci = `${radioNode.nrCellConfig}.${radioNode.cellPci}`;
  const radioCellBasePath = `${radioNode.nrCellBasePath}`;
  const radioCellCommonPath = `${radioNode.cellConfig}.${nrCellNode.ng}.${radioNode.ran}.${radioNode.common}.${radioNode.cellId}`;
  const radioUnitBasePath = `${radioNode.radioUnitBasePath}`;
  let sectorIndex = sectorHubPayload[0]?.index || "";
  let oldRnData = {},
    newRnData = {};

  if (operationType === OPERATIONTYPES.DELETE && !!selectedRadioNode) {
    oldRnData = {};
    newRnData = {
      [`${deletepath}`]: `${radioNodeBasePath}.${selectedRadioNode?.id}.`,
    };
  }

  if (operationType === OPERATIONTYPES.CREATE && !!selectedRadioNode) {
    oldRnData = {};
    newRnData = {
      [`${radioNodeBasePath}`]: provisionIndex,
      [`${radioNodeBasePath}.${provisionIndex}.${radioNode.ethernetId}`]: selectedRadioNode?.ethernetId,
      [`${radioNodeBasePath}.${provisionIndex}.${radioNode.nodeType}`]: selectedRadioNode?.nodeType,
      [`${radioNodeBasePath}.${provisionIndex}.${radioNode.enable}`]: "true",
    };
    if (sectorHubPayload?.length > 0) {
      let sectorHub = sectorHubPayload[0];
      let obj = {
        [`${radioUnitBasePath}`]: sectorHub?.index?.toString(),
        [`${radioUnitBasePath}.${sectorIndex}.${radioNode.ethernetId}`]: sectorHub?.ethernetId,
        [`${radioUnitBasePath}.${sectorIndex}.${radioNode.radioNodeIndex}`]: provisionIndex,
        [`${radioUnitBasePath}.${sectorIndex}.${radioNode.name}`]: sectorHub?.name,
      };
      newRnData = { ...newRnData, ...obj };
    }
    if (radioAddUpdate?.length > 0) {
      const updatedObj = radioAddUpdate?.reduce((result: IKeyValue, el: IRadioListBandData) => {
        let radioIndex = 1 || el?.radio?.toString();
        let obj: IKeyValue = {
          [`${radioUnitBasePath}.${sectorIndex}.${radioNode.radio}.${radioIndex}.${radioNode.band}`]: el?.newBandData || "",
          [`${radioUnitBasePath}.${sectorIndex}.${radioNode.radio}.${radioIndex}.${radioNode.enable}`]: "true",
        };
        return { ...result, ...obj };
      }, {});
      newRnData = { ...newRnData, ...updatedObj };
    }
    if (Array.isArray(cellAddUpdate?.cellLists) && cellAddUpdate?.cellLists?.length > 0) {
      const updatedCellObj = cellAddUpdate?.cellLists?.reduce((result: any, el: ICellCuListPayload) => {
        let radioIndex = 1;
        let cellFormData = el?.cellData;
        let obj = {
          [`${radioCellBasePath}`]: cellFormData?.cellId,
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioCellCommonPath}`]: cellFormData?.commonCellId,
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.radioNode}`]: provisionIndex,
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.cellDescription}`]: cellFormData?.cellDescription,
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.enable}`]: "true",
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioCellPci}`]: cellFormData?.cellPci?.toString(),
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.radio}`]: radioIndex?.toString(),
          [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.cellName}`]: cellFormData?.cellName,
          ...(parseFloat(version) >= 23.4
            ? { [`${radioCellBasePath}.${cellFormData?.cellId}.${nrCellNode.txPower}`]: cellFormData?.txPower }
            : { [`${radioCellBasePath}.${cellFormData?.cellId}.${nrCellNode.pbchPower}`]: cellFormData?.pbchPower }),
        };
        return { ...result, ...obj };
      }, {});
      newRnData = { ...newRnData, ...updatedCellObj };
    }
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: operationType === OPERATIONTYPES.CREATE ? provisionIndex : selectedRadioNode?.id,
    tableId: `${radioNode.tableId}.${operationType === OPERATIONTYPES.CREATE ? provisionIndex : selectedRadioNode?.id}`,
    deviceObjectKey: objectKey,
    oldValue: { ...oldRnData },
    newValue: { ...newRnData },
  };
};

export const prepareRadioLteCellPayload = (
  selectedRadioNode: IRadioNodesDataGridRow | undefined,
  cellFormData: IRnCellInfo,
  initialCellData: IRnCellInfo,
  objectKey: string | undefined,
  operationType: string,
  selectedRadio: string,
  selectedBand: string,
  isCreateRadioCell: string,
  newFormData: any,
  onlyRadioInfoUpt: boolean,
  isMmWType: boolean
) => {
  const { radioNode, deletepath } = xsdPathStr;
  const radioNodeBasePath = `${radioNode.radioNodeBasePath}`;
  const radioNodeIndexPath = `${radioNodeBasePath}.${selectedRadioNode?.id}`;
  const radioLteCellBasePath = `${radioNode.lteCellBasePath}`;
  const radioCellPci = isMmWType ? `${radioNode.nrCellConfig}.${radioNode.cellPci}` : `${radioNode.lteCellConfig}.${radioNode.cellPci}`;
  const radioCellPower = isMmWType ? `${radioNode.nrCellConfig}.${radioNode.power}` : `${radioNode.lteCellConfig}.${radioNode.power}`;
  const radioCellOta = isMmWType ? `${radioNode.nrCellConfig}.${radioNode.actualOta}` : `${radioNode.lteCellConfig}.${radioNode.actualOta}`;
  const radioCellBasePath = isMmWType ? `${radioNode.nrCellBasePath}` : `${radioNode.lteCellBasePath}`;
  const radioCellCommonPath = `${radioNode.cellConfig}.${radioNode.lte}.${radioNode.ran}.${radioNode.common}.${radioNode.cellId}`;
  const radioCellModePath = `${radioNode.cellConfig}.${radioNode.lte}.${radioNode.ran}.${radioNode.rf}.${radioNode.mode}`;
  const radioIndex = selectedRadio === "radio1" ? 1 : 2;
  let oldRnData = {},
    newRnData = {};

  if (operationType === OPERATIONTYPES.CREATE) {
    let payload = {};
    if (isCreateRadioCell === "cell") {
      payload = {
        [`${radioCellBasePath}`]: cellFormData?.cellId,
        [`${radioCellBasePath}.${cellFormData?.cellId}.${radioCellCommonPath}`]: cellFormData?.commonCellId,
        [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.radioNode}`]: selectedRadioNode?.id?.toString(),
        [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.cellDescription}`]: cellFormData?.cellDescription,
        [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.enable}`]: "true",
        [`${radioCellBasePath}.${cellFormData?.cellId}.${radioCellPci}`]: cellFormData?.cellPci?.toString(),
        [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.radio}`]: radioIndex?.toString(),
        [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.cellName}`]: cellFormData?.cellName,
        [`${radioCellBasePath}.${cellFormData?.cellId}.${radioCellPower}`]: cellFormData?.power?.toString(),
        //[`${radioCellBasePath}.${cellFormData?.cellId}.${radioCellOta}`]: cellFormData?.actualOta,
        [`${radioCellBasePath}.${cellFormData?.cellId}.${radioCellModePath}`]: "LTENetmon",
      };
    } else {
      payload = {
        // [`${radioNodeIndexPath}.${radioNode.radio}`]: radioIndex.toString(),
        // [`${radioNodeIndexPath}.${radioNode.radio}.${radioIndex}.${radioNode.band}`]: selectedBand || "",
        // [`${radioNodeIndexPath}.${radioNode.radio}.${radioIndex}.${radioNode.enable}`]: "true",
        [`${radioCellBasePath}`]: cellFormData?.cellId,
        [`${radioCellBasePath}.${cellFormData?.cellId}.${radioCellCommonPath}`]: cellFormData?.commonCellId,
        [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.radioNode}`]: selectedRadioNode?.id?.toString(),
        [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.cellDescription}`]: cellFormData?.cellDescription,
        [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.enable}`]: "true",
        [`${radioCellBasePath}.${cellFormData?.cellId}.${radioCellPci}`]: cellFormData?.cellPci?.toString(),
        [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.radio}`]: radioIndex?.toString(),
        [`${radioCellBasePath}.${cellFormData?.cellId}.${radioNode.cellName}`]: cellFormData?.cellName,
        [`${radioCellBasePath}.${cellFormData?.cellId}.${radioCellPower}`]: cellFormData?.power?.toString(),
        //[`${radioCellBasePath}.${cellFormData?.cellId}.${radioCellOta}`]: cellFormData?.actualOta,
        [`${radioCellBasePath}.${cellFormData?.cellId}.${radioCellModePath}`]: "LTENetmon",
      };
    }
    oldRnData = {};
    newRnData = { ...payload };
  }

  if (operationType === OPERATIONTYPES.UPDATE) {
    Object.entries(initialCellData).forEach(([oldkey, oldvalue]) => {
      Object.entries(cellFormData).forEach(([newkey, newvalue]) => {
        if (oldkey === newkey && oldvalue !== newvalue && oldkey !== "status") {
          if (oldkey === "cellPci") {
            oldRnData = { ...oldRnData, [`${radioLteCellBasePath}.${cellFormData?.cellId}.${radioCellPci}`]: oldvalue };
            newRnData = { ...newRnData, [`${radioLteCellBasePath}.${cellFormData?.cellId}.${radioCellPci}`]: newvalue?.toString() };
          } else if (oldkey === "power") {
            oldRnData = { ...oldRnData, [`${radioLteCellBasePath}.${cellFormData?.cellId}.${radioCellPower}`]: oldvalue };
            newRnData = { ...newRnData, [`${radioLteCellBasePath}.${cellFormData?.cellId}.${radioCellPower}`]: newvalue?.toString() };
          } else if (oldkey === "actualOta") {
            oldRnData = { ...oldRnData, [`${radioLteCellBasePath}.${cellFormData?.cellId}.${radioCellOta}`]: oldvalue };
            newRnData = { ...newRnData, [`${radioLteCellBasePath}.${cellFormData?.cellId}.${radioCellOta}`]: newvalue?.toString() };
          } else if (oldkey === "commonCellId") {
            oldRnData = { ...oldRnData, [`${radioCellBasePath}.${cellFormData?.cellId}.${radioCellCommonPath}`]: oldvalue };
            newRnData = { ...newRnData, [`${radioCellBasePath}.${cellFormData?.cellId}.${radioCellCommonPath}`]: newvalue?.toString() };
          } else {
            oldRnData = { ...oldRnData, [`${radioLteCellBasePath}.${cellFormData?.cellId}.${radioNode[oldkey]}`]: oldvalue };
            newRnData = { ...newRnData, [`${radioLteCellBasePath}.${cellFormData?.cellId}.${radioNode[newkey]}`]: newvalue?.toString() };
          }
        }
      });
    });
    if (newFormData?.hasOwnProperty("latitude")) {
      oldRnData = { ...oldRnData, [`${radioNodeIndexPath}.Location.Latitude`]: newFormData?.oldLatitude };
      newRnData = { ...newRnData, [`${radioNodeIndexPath}.Location.Latitude`]: selectedRadioNode?.latitude };
    }
    if (newFormData?.hasOwnProperty("longitude")) {
      oldRnData = { ...oldRnData, [`${radioNodeIndexPath}.Location.Longitude`]: newFormData?.oldLongitude };
      newRnData = { ...newRnData, [`${radioNodeIndexPath}.Location.Longitude`]: selectedRadioNode?.longitude };
    }
    if (newFormData?.hasOwnProperty("description")) {
      oldRnData = { ...oldRnData, [`${radioNodeIndexPath}.Description`]: newFormData?.oldDescription };
      newRnData = { ...newRnData, [`${radioNodeIndexPath}.Description`]: selectedRadioNode?.description };
    }
    if (newFormData?.hasOwnProperty("name")) {
      oldRnData = { ...oldRnData, [`${radioNodeIndexPath}.Name`]: newFormData?.oldName };
      newRnData = { ...newRnData, [`${radioNodeIndexPath}.Name`]: selectedRadioNode?.name };
    }
    oldRnData = { ...oldRnData };
    newRnData = { ...newRnData };
  }

  if (operationType === OPERATIONTYPES.DELETE) {
    oldRnData = {};
    newRnData = {
      [`${deletepath}`]: `${radioLteCellBasePath}.${cellFormData?.cellId}.`,
    };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: onlyRadioInfoUpt !== true ? `${selectedRadioNode?.id}` : `${cellFormData?.cellId}`,
    tableId: onlyRadioInfoUpt !== true ? `${radioNode.tableId}.${selectedRadioNode?.id}` : `${radioNode.cellTableId}.${cellFormData?.cellId}`,
    deviceObjectKey: objectKey,
    oldValue: { ...oldRnData },
    newValue: { ...newRnData },
  };
};

export const prepareRemoveRadioLteCellPayload = (
  selectedRadioNode: IRadioNodesDataGridRow | undefined,
  cellFormData: IRnCellInfo,
  objectKey: string | undefined,
  operationType: string,
  selectedRadio: string
) => {
  const { radioNode, deletepath } = xsdPathStr;
  const radioLteCellBasePath = `${radioNode.lteCellBasePath}`;
  let oldRnData = {},
    newRnData = {};

  if (operationType === OPERATIONTYPES.DELETE) {
    oldRnData = {};
    newRnData = {
      [`${deletepath}`]: `${radioLteCellBasePath}.${cellFormData?.cellId}.`,
    };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: cellFormData?.cellId?.toString(),
    tableId: `${radioNode.cellTableId}.${cellFormData?.cellId}`,
    deviceObjectKey: objectKey,
    oldValue: { ...oldRnData },
    newValue: { ...newRnData },
  };
};

export const prepareRemoveRadioNrCellPayload = (
  selectedRadioNode: IDusNodeDataGridRow | undefined,
  cellFormData: IDuCellInfo,
  objectKey: string | undefined,
  operationType: string,
  selectedRadio: string
) => {
  const { nrCellNode, deletepath } = xsdPathStr;
  const radioNrCellBasePath = `${nrCellNode.nrCellBasePath}`;
  let oldRnData = {},
    newRnData = {};

  if (operationType === OPERATIONTYPES.DELETE) {
    oldRnData = {};
    newRnData = {
      [`${deletepath}`]: `${radioNrCellBasePath}.${cellFormData?.cellId}.`,
    };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: cellFormData?.cellId?.toString(),
    tableId: `${nrCellNode.tableId}.${cellFormData?.cellId}`,
    deviceObjectKey: objectKey,
    oldValue: { ...oldRnData },
    newValue: { ...newRnData },
  };
};

export const prepareRadioNrCellPayload = (
  selectedRadioNode: IDusNodeDataGridRow | undefined,
  cellFormData: IDuCellInfo,
  initialCellData: IDuCellInfo,
  objectKey: string | undefined,
  operationType: string,
  selectedRadio: string,
  selectedBand: string,
  isCreateRadioCell: string,
  newFormData: any,
  onlyRadioInfoUpt: boolean,
  version: string
) => {
  const { nrCellNode, deletepath } = xsdPathStr;
  const radioNodeBasePath = `${nrCellNode.radioNodeBasePath}`;
  const radioNodeIndexPath = `${radioNodeBasePath}.${selectedRadioNode?.id}`;
  const radioUnitIndexPath = `${nrCellNode.radioUnitBasePath}.${selectedRadioNode?.id}`;
  const radioNrCellBasePath = `${nrCellNode.nrCellBasePath}`;
  const radioCellCommonPath = `${nrCellNode.cellConfig}.${nrCellNode.ng}.${nrCellNode.ran}.${nrCellNode.common}.${nrCellNode.cellId}`;
  //  const radioCellModePath = `${nrCellNode.cellConfig}.${nrCellNode.nr}.${nrCellNode.ran}.${nrCellNode.rf}.${nrCellNode.mode}`;
  const radioIndex = selectedRadio === "radio1" ? 1 : 2;
  let oldRnData = {},
    newRnData = {};

  if (operationType === OPERATIONTYPES.CREATE) {
    let payload = {};
    if (isCreateRadioCell === "cell") {
      payload = {
        [`${radioNrCellBasePath}`]: cellFormData?.cellId?.toString(),
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radioNode}`]: selectedRadioNode?.id?.toString(),
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.enable}`]: "true",
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radioConfiguration}.1.${nrCellNode.radioIndex}`]: radioIndex?.toString(),
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.cellDescription}`]: cellFormData?.cellDescription,
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radioConfiguration}.1.${nrCellNode.enable}`]: "true",
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.cellName}`]: cellFormData?.cellName,
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radioConfiguration}.1.${nrCellNode.radioUnitIndex}`]:
          selectedRadioNode?.radioUnit?.index,
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${radioCellCommonPath}`]: cellFormData?.commonCellId,
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.cellPci}`]: cellFormData?.cellPci,
        ...(parseFloat(version) >= 23.4
          ? { [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.txPower}`]: cellFormData?.txPower }
          : { [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.pbchPower}`]: cellFormData?.pbchPower }),
        // [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radioConfiguration}`]: "1",
        //[`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radio}`]: radioIndex?.toString(),
        // [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.actualOta}`]: cellFormData?.actualOta,
      };
    } else {
      payload = {
        [`${radioUnitIndexPath}.${nrCellNode.radio}`]: radioIndex?.toString(),
        [`${radioUnitIndexPath}.${nrCellNode.radio}.${radioIndex}.${nrCellNode.band}`]: selectedBand || "nr-band-77",
        [`${radioUnitIndexPath}.${nrCellNode.radio}.${radioIndex}.${nrCellNode.enable}`]: "true",
        [`${radioNrCellBasePath}`]: cellFormData?.cellId?.toString(),
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radioNode}`]: selectedRadioNode?.id?.toString(),
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${radioCellCommonPath}`]: cellFormData?.commonCellId,
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.cellDescription}`]: cellFormData?.cellDescription,
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.cellPci}`]: cellFormData?.cellPci,
        //[`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radio}`]: radioIndex?.toString(),
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.cellName}`]: cellFormData?.cellName,
        // [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.txPower}`]: cellFormData?.txPower,
        ...(parseFloat(version) >= 23.4
          ? { [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.txPower}`]: cellFormData?.txPower }
          : { [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.pbchPower}`]: cellFormData?.pbchPower }),
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radioConfiguration}.1.${nrCellNode.radioUnitIndex}`]:
          selectedRadioNode?.radioUnit?.index,
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radioConfiguration}.1.${nrCellNode.radioIndex}`]: radioIndex?.toString(),
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radioConfiguration}.1.${nrCellNode.enable}`]: "true",
        //[`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.actualOta}`]: cellFormData?.actualOta,
      };
    }
    oldRnData = {};
    newRnData = { ...payload };
  }

  if (operationType === OPERATIONTYPES.UPDATE) {
    Object.entries(initialCellData).forEach(([oldkey, oldvalue]) => {
      Object.entries(cellFormData).forEach(([newkey, newvalue]) => {
        if (oldkey === newkey && oldvalue !== newvalue) {
          if (oldkey === "commonCellId") {
            oldRnData = { ...oldRnData, [`${radioNrCellBasePath}.${cellFormData?.cellId}.${radioCellCommonPath}`]: oldvalue };
            newRnData = { ...newRnData, [`${radioNrCellBasePath}.${cellFormData?.cellId}.${radioCellCommonPath}`]: newvalue?.toString() };
          }
          oldRnData = { ...oldRnData, [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode[oldkey]}`]: oldvalue };
          newRnData = { ...newRnData, [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode[newkey]}`]: newvalue?.toString() };
        }
      });
    });
    if (newFormData?.hasOwnProperty("description")) {
      oldRnData = { ...oldRnData, [`${radioNodeIndexPath}.Description`]: newFormData?.oldDescription };
      newRnData = { ...newRnData, [`${radioNodeIndexPath}.Description`]: selectedRadioNode?.description };
    }
    if (newFormData?.hasOwnProperty("name")) {
      oldRnData = { ...oldRnData, [`${radioNodeIndexPath}.Name`]: newFormData?.oldName };
      newRnData = { ...newRnData, [`${radioNodeIndexPath}.Name`]: selectedRadioNode?.name };
    }
    oldRnData = { ...oldRnData };
    newRnData = { ...newRnData };
  }

  if (operationType === OPERATIONTYPES.DELETE) {
    oldRnData = {};
    newRnData = {
      [`${deletepath}`]: `${radioNrCellBasePath}.${cellFormData?.cellId}.`,
    };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: onlyRadioInfoUpt !== true ? `${selectedRadioNode?.id}` : `${cellFormData?.cellId}`,
    tableId: onlyRadioInfoUpt !== true ? `${nrCellNode.radioNode}.${selectedRadioNode?.id}` : `${nrCellNode.tableId}.${cellFormData?.cellId}`,
    deviceObjectKey: objectKey,
    oldValue: { ...oldRnData },
    newValue: { ...newRnData },
  };
};

export const prepareRadioCuNrCellPayload = (
  selectedRadioNode: IDusNodeDataGridRow | undefined,
  cellFormData: IDuCellInfo,
  initialCellData: IDuCellInfo,
  objectKey: string | undefined,
  operationType: string,
  selectedRadio: string,
  isCreateRadioCell: string,
  newFormData: any,
  onlyRadioInfoUpt: boolean,
  version: string
) => {
  const { nrCellNode, deletepath } = xsdPathStr;
  const radioNodeBasePath = `${nrCellNode.radioNodeBasePath}`;
  const radioNodeIndexPath = `${radioNodeBasePath}.${selectedRadioNode?.id}`;
  const radioUnitIndexPath = `${nrCellNode.radioUnitBasePath}.${selectedRadioNode?.id}`;
  const radioNrCellBasePath = `${nrCellNode.nrCellBasePath}`;
  const radioCellCommonPath = `${nrCellNode.cellConfig}.${nrCellNode.ng}.${nrCellNode.ran}.${nrCellNode.common}.${nrCellNode.cellId}`;
  //  const radioCellModePath = `${nrCellNode.cellConfig}.${nrCellNode.nr}.${nrCellNode.ran}.${nrCellNode.rf}.${nrCellNode.mode}`;
  const radioIndex = selectedRadio === "radio1" ? 1 : 2;
  let oldRnData = {},
    newRnData = {};

  if (operationType === OPERATIONTYPES.CREATE) {
    let payload = {};
    if (isCreateRadioCell === "cell") {
      payload = {
        [`${radioNrCellBasePath}`]: cellFormData?.cellId?.toString(),
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radioNode}`]: selectedRadioNode?.id?.toString(),
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.enable}`]: "true",
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radio}`]: radioIndex?.toString(),
        //[`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radioConfiguration}.1.${nrCellNode.radioIndex}`]: radioIndex?.toString(),
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.cellDescription}`]: cellFormData?.cellDescription,
        //[`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radioConfiguration}.1.${nrCellNode.enable}`]: "true",
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.cellName}`]: cellFormData?.cellName,
        //[`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radioConfiguration}.1.${nrCellNode.radioUnitIndex}`]:
        //selectedRadioNode?.radioUnit?.index,
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${radioCellCommonPath}`]: cellFormData?.commonCellId,
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.cellPci}`]: cellFormData?.cellPci,
        ...(parseFloat(version) >= 23.4
          ? { [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.txPower}`]: cellFormData?.txPower }
          : { [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.pbchPower}`]: cellFormData?.pbchPower }),
        // [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radioConfiguration}`]: "1",
        //[`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radio}`]: radioIndex?.toString(),
        // [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.actualOta}`]: cellFormData?.actualOta,
      };
    } else {
      payload = {
        [`${radioUnitIndexPath}.${nrCellNode.radio}`]: radioIndex?.toString(),
        //[`${radioUnitIndexPath}.${nrCellNode.radio}.${radioIndex}.${nrCellNode.band}`]: selectedBand || "",
        [`${radioUnitIndexPath}.${nrCellNode.radio}.${radioIndex}.${nrCellNode.enable}`]: "true",
        [`${radioNrCellBasePath}`]: cellFormData?.cellId?.toString(),
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radioNode}`]: selectedRadioNode?.id?.toString(),
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${radioCellCommonPath}`]: cellFormData?.commonCellId,
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.cellDescription}`]: cellFormData?.cellDescription,
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.cellPci}`]: cellFormData?.cellPci,
        //[`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radio}`]: radioIndex?.toString(),
        [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.cellName}`]: cellFormData?.cellName,
        // [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.txPower}`]: cellFormData?.txPower,
        ...(parseFloat(version) >= 23.4
          ? { [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.txPower}`]: cellFormData?.txPower }
          : { [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.pbchPower}`]: cellFormData?.pbchPower }),
        // [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radioConfiguration}.1.${nrCellNode.radioUnitIndex}`]:
        //   selectedRadioNode?.radioUnit?.index,
        // [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radioConfiguration}.1.${nrCellNode.radioIndex}`]: radioIndex?.toString(),
        // [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.radioConfiguration}.1.${nrCellNode.enable}`]: "true",
        //[`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode.actualOta}`]: cellFormData?.actualOta,
      };
    }
    oldRnData = {};
    newRnData = { ...payload };
  }

  if (operationType === OPERATIONTYPES.UPDATE) {
    Object.entries(initialCellData).forEach(([oldkey, oldvalue]) => {
      Object.entries(cellFormData).forEach(([newkey, newvalue]) => {
        if (oldkey === newkey && oldvalue !== newvalue && oldkey !== "status") {
          if (oldkey === "commonCellId") {
            oldRnData = { ...oldRnData, [`${radioNrCellBasePath}.${cellFormData?.cellId}.${radioCellCommonPath}`]: oldvalue };
            newRnData = { ...newRnData, [`${radioNrCellBasePath}.${cellFormData?.cellId}.${radioCellCommonPath}`]: newvalue?.toString() };
          }
          oldRnData = { ...oldRnData, [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode[oldkey]}`]: oldvalue };
          newRnData = { ...newRnData, [`${radioNrCellBasePath}.${cellFormData?.cellId}.${nrCellNode[newkey]}`]: newvalue?.toString() };
        }
      });
    });
    if (newFormData?.hasOwnProperty("description")) {
      oldRnData = { ...oldRnData, [`${radioNodeIndexPath}.Description`]: newFormData?.oldDescription };
      newRnData = { ...newRnData, [`${radioNodeIndexPath}.Description`]: selectedRadioNode?.description };
    }
    if (newFormData?.hasOwnProperty("name")) {
      oldRnData = { ...oldRnData, [`${radioNodeIndexPath}.Name`]: newFormData?.oldName };
      newRnData = { ...newRnData, [`${radioNodeIndexPath}.Name`]: selectedRadioNode?.name };
    }
    oldRnData = { ...oldRnData };
    newRnData = { ...newRnData };
  }

  if (operationType === OPERATIONTYPES.DELETE) {
    oldRnData = {};
    newRnData = {
      [`${deletepath}`]: `${radioNrCellBasePath}.${cellFormData?.cellId}.`,
    };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: onlyRadioInfoUpt !== true ? `${selectedRadioNode?.id}` : `${cellFormData?.cellId}`,
    tableId: onlyRadioInfoUpt !== true ? `${nrCellNode.radioNode}.${selectedRadioNode?.id}` : `${nrCellNode.tableId}.${cellFormData?.cellId}`,
    deviceObjectKey: objectKey,
    oldValue: { ...oldRnData },
    newValue: { ...newRnData },
  };
};

export const prepareNrCellPayload = (selectedNrCell: INrCellDataGridRow | undefined, objectKey: string, operationType: string) => {
  const { nrCell, deletepath } = xsdPathStr;
  const nrCellBasePath = `${nrCell.nrCellBasePath}`;
  //  const nrCellIndexPath = `${nrCellBasePath}.${selectedNrCell?.id}`;
  let oldNrCellData = {},
    newNrCellData = {};

  if (operationType === OPERATIONTYPES.DELETE && !!selectedNrCell) {
    oldNrCellData = {};
    newNrCellData = {
      [`${deletepath}`]: `${nrCellBasePath}.${selectedNrCell?.id}.`,
    };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: selectedNrCell?.id,
    tableId: `${nrCell.tableId}.${selectedNrCell?.id}`,
    deviceObjectKey: objectKey,
    oldValue: { ...oldNrCellData },
    newValue: { ...newNrCellData },
  };
};

export const prepareLteCellPayload = (selectedLteCell: ILteCellDataGridRow | undefined, objectKey: string, operationType: string) => {
  const { lteCell, deletepath } = xsdPathStr;
  const lteCellBasePath = `${lteCell.lteCellBasePath}`;
  //  const lteCellIndexPath = `${lteCellBasePath}.${selectedLteCell?.id}`;
  let oldLteCellData = {},
    newLteCellData = {};

  if (operationType === OPERATIONTYPES.DELETE && !!selectedLteCell) {
    oldLteCellData = {};
    newLteCellData = {
      [`${deletepath}`]: `${lteCellBasePath}.${selectedLteCell?.id}.`,
    };
  }

  return {
    operationType: operationType,
    userId: localStorage.getItem(LOCAL_STORAGE.USER),
    rowkey: selectedLteCell?.id,
    tableId: `${lteCell.tableId}.${selectedLteCell?.id}`,
    deviceObjectKey: objectKey,
    oldValue: { ...oldLteCellData },
    newValue: { ...newLteCellData },
  };
};
